<template>
	<div>
		<table-filter :filters="filters"/>
		<div class="nothing-to-see-here" v-if="loaded && !items.length">
			<p>Nothing to display.</p>
		</div>
		<table role="grid" v-if="loaded && items.length">
			<thead>
				<tr>
					<th align="left">Outward</th>
					<th align="right">Number Of Searches</th>
					<th align="right" class="actions"><span>Actions</span></th>
				</tr>
			</thead>
			<tfoot>
				<tr>
					<th align="left">Outward</th>
					<th align="right">Number Of Searches</th>
					<th align="right" class="actions"><span>Actions</span></th>
				</tr>
			</tfoot>
			<tbody>
				<tr v-for="(postcodeGeometry, postcodeGeometryIndex) in items" :key="postcodeGeometryIndex">
					<td v-html="postcodeGeometry.outward"/>
					<td align="right" v-html="postcodeGeometry.postcodeSearches.length"/>
					<td align="right">
						<v-contextual>
							<v-contextual-option
								:route-to="{name: 'tools.postcodeManager.unlinked', params: {postcodeGeometry: postcodeGeometry.id}}">View</v-contextual-option>
						</v-contextual>
					</td>
				</tr>
			</tbody>
		</table>
		<paginator :meta="meta" :links="links"></paginator>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("unlinkedPostcodes");

export default {
	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
	},

	created() {
		if (this.loaded) {
			return;
		}
		this.getModels();
	},
};
</script>
